import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import dayjs from 'dayjs';
import { map, switchMap } from 'rxjs/operators';

import { ButtonComponent } from '@shared/components/button/button.component';
import { ApiService } from '@shared/services/api.service';
import { OverlayService } from '@shared/services/overlay.service';
import { MainQuery } from '@shared/store/main/main.query';
import { signalRequestWithRefresh } from '@shared/utils/signal-request-with-refresh';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
  selector: 'aux-qc-download-vendor-estimate',
  template: `
    <aux-button
      (click)="onDownloadVendorEstimates()"
      [disabled]="disabled()"
      variant="secondary"
      label="Download Vendor Estimate(s)"
    />
  `,
})
export class DownloadVendorEstimateComponent {
  apiService = inject(ApiService);
  mainQuery = inject(MainQuery);
  overlayService = inject(OverlayService);

  currentOpenMonth = computed(() => dayjs(this.mainQuery.currentOpenMonth()).format('MMMM-YYYY'));

  fileCount = signalRequestWithRefresh(
    toObservable(this.currentOpenMonth).pipe(
      switchMap((month) => {
        const { trialKey } = this.mainQuery.getValue();

        return this.apiService.fileCounts(`trials/${trialKey}/vendors/vendor-estimate/${month}`);
      }),
      map((count) => count)
    ),
    0
  );

  disabled = computed(() => this.fileCount.value() === 0);

  async onDownloadVendorEstimates() {
    const { trialKey } = this.mainQuery.getValue();

    const { data, success } = await this.apiService.getS3ZipFile(
      `trials/${trialKey}/vendors/vendor-estimate/${this.currentOpenMonth()}`
    );

    if (success && data) {
      // [insert trial name]_[insert vendor name]_Change Order [insert Change Order #]_[insert date created YYYY.MM.DD]
      const fileName = `vendor-estimate`;

      await this.apiService.downloadZipOrFile(data, fileName);
    }
  }
}
